import { MessageSquare, FileText, FolderOpen } from 'lucide-react'
import { useContentDStore } from '@/stores/useContentDStore'
import { cn } from '@/lib/utils'

type MobileView = 'sessions' | 'chat' | 'document'

interface NavTab {
  id: MobileView
  icon: typeof MessageSquare
  label: string
}

const tabs: NavTab[] = [
  { id: 'chat', icon: MessageSquare, label: 'Chat' },
  { id: 'document', icon: FileText, label: 'Document' },
  { id: 'sessions', icon: FolderOpen, label: 'Sessions' },
]

export function ContentDMobileNav() {
  const { mobileView, setMobileView, workflowStatus } = useContentDStore()

  // Show streaming indicator on Chat tab when workflow is active
  const isStreaming = workflowStatus === 'streaming' || workflowStatus === 'processing'

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-t border-border md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-14 pb-safe">
        {tabs.map((tab) => {
          const Icon = tab.icon
          const isActive = mobileView === tab.id
          const showStreamingDot = tab.id === 'chat' && isStreaming && !isActive

          return (
            <button
              key={tab.id}
              onClick={() => setMobileView(tab.id)}
              className={cn(
                'relative flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors',
                'active:bg-muted/50 min-w-[64px]',
                isActive
                  ? 'text-foreground'
                  : 'text-muted-foreground'
              )}
            >
              <div className="relative">
                <Icon
                  className={cn(
                    'w-5 h-5 transition-all',
                    isActive && 'scale-105'
                  )}
                  strokeWidth={isActive ? 2 : 1.5}
                />
                {/* Streaming indicator dot */}
                {showStreamingDot && (
                  <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                )}
              </div>
              <span
                className={cn(
                  'text-[10px] leading-none',
                  isActive ? 'font-medium' : 'font-normal'
                )}
              >
                {tab.label}
              </span>
              {/* Active indicator line */}
              {isActive && (
                <div className="absolute bottom-1.5 w-8 h-0.5 bg-foreground rounded-full" />
              )}
            </button>
          )
        })}
      </div>
    </nav>
  )
}
